import React from "react";
import "../../../css/BoletinOficial/resoluciones-jem.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook } from "@fortawesome/free-solid-svg-icons";

// Resoluciones numeradas
const RESOLUCIONES = [
  { numero: 1, texto: "Resolución Nº 1 - Anexo Cronograma Electoral" },
  { numero: 2, texto: "Resolución Nº 2" },
  { numero: 3, texto: "Resolución Nº 3" },
  { numero: 4, texto: "Resolución Nº 4" },
  { numero: 5, texto: "Resolución Nº 5" },
  { numero: 6, texto: "Resolución Nº 6" },
  { numero: 7, texto: "Resolución Nº 7" },
  { numero: 8, texto: "Resolución Nº 8" },
  { numero: 9, texto: "Resolución Nº 9" },
  { numero: 10, texto: "Resolución Nº 10" },
  { numero: 11, texto: "Resolución Nº 11" },
  { numero: 12, texto: "Resolución Nº 12" },
  { numero: 13, texto: "Resolución Nº 13" },
  { numero: 14, texto: "Resolución Nº 14" },
  { numero: 15, texto: "Resolución Nº 15" },
  { numero: 16, texto: "Resolución Nº 16" },
  { numero: 17, texto: "Resolución Nº 17" },
];

// Resoluciones con anexos o nombres especiales
const ANEXOS = [
  {
    texto: "Resolución Nº 15 - Anexo Boleta Única de Sufragio",
    url: "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/resoluciones-jem/boleta-unica-sufragio.pdf",
  },
  {
    texto: "Resolución Nº 18 - Anexo Acta N° 8 y Reglamento del Debate",
    url: "https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/resoluciones-jem/JEM-resolucion-18.pdf",
  },
];

const urlResolucion = (numero) =>
  `https://ciudaddeoliva.gov.ar/file/pdf/web-oliva/resoluciones-jem/JEM-resolucion-${numero}.pdf`;

const ResolucionesJEM = () => (
  <div className="decretos-full-bg">
    <div className="decretos-container">
      <h1 className="decretos-title">RESOLUCIONES JUNTA ELECTORAL MUNICIPAL</h1>
      <p className="decretos-desc">
        Un gobierno abierto y transparente que pone a disposición de los ciudadanos información relevante para promover mayor participación y cercanía.
      </p>
      <div className="row resolucionesjem-list">
        {RESOLUCIONES.map((res) => (
            <div className="resolucionesjem-link" key={res.numero}>
          <a
            key={res.numero}
            href={urlResolucion(res.numero)}
            target="_blank"
            rel="noopener noreferrer"
            className=""
          >
            <FontAwesomeIcon icon={faBook} className="resolucionesjem-icon" />
            &nbsp;{res.texto}
          </a>
          </div>
        ))}
        {ANEXOS.map((anexo, idx) => (
          <a
            key={anexo.texto}
            href={anexo.url}
            target="_blank"
            rel="noopener noreferrer"
            className="resolucionesjem-link"
          >
            <FontAwesomeIcon icon={faBook} className="resolucionesjem-icon" />
            {anexo.texto}
          </a>
        ))}
      </div>
    </div>
  </div>
);

export default ResolucionesJEM;